import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { ExternalAgent } from "../models/ExternalAgent";

export const useGetExternalAgent = () => {
  const {
    data: externalAgent,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<ExternalAgent>(
    (response) => new ExternalAgent(response),
  );

  const getExternalAgent = async (agentName: string) => {
    await call(`/admin/externalAgents/${agentName}`, "GET");
  };

  return {
    externalAgent,
    getExternalAgent,
    isLoading,
    isFailed,
  };
};
